import * as React from "react";
import Svg, { Path } from "react-native-svg";

const RRDStatus = (props) => {
  if (props.status === "MARKED_PICKUP_FROM_CX") {
    return (
      <Svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Path
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2Z"
          fill="#FF2E00"
        />
        <Path
          d="M18 16.7354C17.8937 16.9496 17.7499 17.033 17.5685 16.9883C17.4153 16.9526 17.334 16.8544 17.2996 16.7116C16.7931 14.6551 15.4205 13.4141 13.2976 12.8844C12.8942 12.7832 12.4784 12.7415 12.0594 12.7177C11.9781 12.7118 11.9719 12.7385 11.9719 12.801C11.975 13.3605 11.975 13.92 11.9719 14.4825C11.9719 14.7295 11.7936 14.8813 11.556 14.8486C11.4935 14.8396 11.4372 14.8099 11.3872 14.7742C9.65503 13.5927 7.9135 12.4112 6.17509 11.2327C6.09693 11.1791 6.05315 11.1047 6 11.0333C6 10.9737 6 10.9142 6 10.8547C6.01876 10.7416 6.09067 10.6672 6.1876 10.6017C7.69776 9.57797 9.20792 8.55421 10.715 7.53045C10.9276 7.38462 11.1402 7.24177 11.3528 7.09892C11.4872 7.00964 11.6311 6.95904 11.7905 7.04237C11.9437 7.1257 12.0094 7.25665 12.0063 7.42331C12.0031 7.95305 12.0063 8.48278 12.0063 9.0155C12.0063 9.13751 11.9812 9.16727 12.1563 9.18811C12.9098 9.27739 13.629 9.48571 14.3075 9.8101C15.4268 10.3458 16.296 11.1344 16.9244 12.1612C17.3246 12.8189 17.5967 13.5242 17.7686 14.2623C17.8656 14.67 17.9375 15.0837 17.9719 15.5033C17.9844 15.6759 17.9781 15.8485 18 16.0211C18 16.2592 18 16.4973 18 16.7354Z"
          fill="white"
        />
      </Svg>
    );
  } else if (props.status === "delayedCustomers") {
    return (
      <Svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Path
          d="M14.6493 16.9637C11.5177 19.0148 8.44113 19.0087 5.35843 16.9759C4.6137 17.7207 3.85676 18.4776 3.11203 19.2162C2.59316 18.6974 2.0987 18.2029 1.58594 17.6902C2.31846 16.9637 3.0815 16.2007 3.85676 15.4315C2.44665 13.4537 1.99493 11.2928 2.58095 8.94872C3.01436 7.20288 3.97884 5.78056 5.43168 4.7123C8.4045 2.51474 12.4761 2.7467 15.1803 5.22507C17.9151 7.73396 18.5805 12.1108 16.1387 15.4193C16.8957 16.1824 17.6465 16.9454 18.3851 17.6841C17.8724 18.1968 17.3779 18.6913 16.8712 19.1918C16.1448 18.4654 15.394 17.7146 14.6493 16.9637ZM9.05767 7.24561C9.05767 8.88768 9.05767 10.4992 9.05767 12.1108C9.662 12.1108 10.2419 12.1108 10.8218 12.1108C10.8218 10.4748 10.8218 8.86326 10.8218 7.24561C10.2236 7.24561 9.64368 7.24561 9.05767 7.24561ZM9.03325 13.0264C9.03325 13.4354 9.02714 13.8139 9.03935 14.1924C9.03935 14.2351 9.11261 14.3144 9.15534 14.3144C9.71083 14.3206 10.2663 14.3206 10.8218 14.3206C10.8218 13.8688 10.8218 13.4476 10.8218 13.0264C10.2236 13.0264 9.64368 13.0264 9.03325 13.0264Z"
          fill="#FF2E00"
        />
        <Path
          d="M6.39007 2.08124C4.82735 3.39367 3.28295 4.68779 1.72024 6.00023C1.07318 5.18225 0.84121 4.2788 1.1098 3.296C1.43333 2.07513 2.23911 1.30598 3.48439 1.06181C4.6198 0.842052 5.57819 1.21442 6.39007 2.08124Z"
          fill="#FF2E00"
        />
        <Path
          d="M18.2265 6.00024C16.6577 4.68781 15.1194 3.39368 13.5566 2.08735C14.2281 1.32431 15.0583 0.945838 16.0533 1.01299C17.3352 1.09845 18.2509 1.75772 18.7209 2.94807C19.1482 4.03464 18.9468 5.04796 18.2265 6.00024Z"
          fill="#FF2E00"
        />
        <Path
          d="M9.05762 7.24561C9.64974 7.24561 10.2235 7.24561 10.8218 7.24561C10.8218 8.86326 10.8218 10.4809 10.8218 12.1108C10.2419 12.1108 9.66195 12.1108 9.05762 12.1108C9.05762 10.5053 9.05762 8.88768 9.05762 7.24561Z"
          fill="white"
        />
        <Path
          d="M9.0332 13.0264C9.64364 13.0264 10.2236 13.0264 10.8157 13.0264C10.8157 13.4476 10.8157 13.8688 10.8157 14.3205C10.2602 14.3205 9.70468 14.3205 9.14919 14.3144C9.10645 14.3144 9.0332 14.235 9.0332 14.1923C9.0332 13.8138 9.0332 13.4293 9.0332 13.0264Z"
          fill="white"
        />
      </Svg>
    );
  } else if (
    props.status === ("MARKED_DELIVERY_TO_CX" || "MARKED_REFUND_TO_CX")
  ) {
    return (
      <Svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Path
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2Z"
          fill="#00AB59"
        />
        <Path
          d="M9.24156 15.7559L6.24421 12.7595C5.9186 12.434 5.9186 11.9082 6.24421 11.5827C6.56983 11.2572 7.09583 11.2572 7.42144 11.5827L9.83435 13.9864L15.5786 8.24413C15.9042 7.91862 16.4302 7.91862 16.7558 8.24413C17.0814 8.56964 17.0814 9.09546 16.7558 9.42097L10.4188 15.7559C10.1015 16.0814 9.56717 16.0814 9.24156 15.7559Z"
          fill="white"
        />
      </Svg>
    );
  } else return null;
};

export default RRDStatus;
